module.exports = __webpack_public_path__ + "img/kargo.4d2ea220.png";